<template>
  <div class="pc-bank-card-wrap">
    <div class="pc-bank-card" :class="type">
      <div class="pc-bank-card__content">
        <template v-if="type !== 'blank'">
          <div class="pc-currencies">
            <div v-for="currency in currencies" :key="currency" class="pc-currency">
              <icu-icon
                :class="{['pc-' + $options.currencies[currency].symbol]: true, 'active': accountData.currency_in_use && accountData.currency_in_use.includes(currency)}"
              ></icu-icon>
            </div>
          </div>
          <template v-if="['inactive', 'inactive-account'].includes(type)">
            <div class="pc-bank-card__in-process">
              <icu-icon class="pc-clock" /> {{ $t('pc.general.in-process') }}
            </div>
          </template>
          <template v-else>
            <div class="pc-actions">
              <template v-if="accountData.currency.includes(1)">
                <div class="pc-action-btn" @click="showCardManage">
                  <icu-icon class="pc-edit"></icu-icon><span>{{ $t('pc.accounts.card-manage') }}</span>
                </div>
              </template>
              <template v-if="currenciesForPayoutSet.length">
                <v-tooltip
                  v-if="!noNeedToShowModal"

                  theme="pc-currency-change"
                >
                  <div v-if="accountData.is_loading" class="pc-action-btn loading">
                    <icu-icon class="pc-small-loader"></icu-icon>
                  </div>
                  <div v-else class="pc-action-btn">
                    <icu-icon class="pc-wallet"></icu-icon>
                    <span>{{ $t('pc.accounts.withdraw-make') }}</span>
                  </div>
                  <template #popper>
                    <div class="popper-content">
                      <div class="popper-content__text">
                        {{ $t('pc.accounts.choose-currency') }}
                        <pc-checkbox-input
                          :disabled="false"
                          class="pc-checkbox"
                          :value="currency.includes(2)"
                          @click.native="updateCurrency(2)"
                        >
                          {{ $t('pc.accounts.usd') }}, $
                        </pc-checkbox-input>
                        <pc-checkbox-input
                          class="pc-verification-checkbox"
                          :value="currency.includes(3)"
                          @click.native="updateCurrency(3)"
                        >
                          {{ $t('pc.accounts.eur') }},  €
                        </pc-checkbox-input>

                        <div class="poper__confirm-wrap">
                          <pc-button
                            variant="void"
                            class="poper__confirm"
                            :disabled="!currency.length"
                            @click.native="addWithdraw( true)"
                          >
                            {{ $t('pc.accounts.save-choose') }}
                          </pc-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </v-tooltip>
                <template v-else>
                  <div v-if="accountData.is_loading" class="pc-action-btn loading">
                    <icu-icon class="pc-small-loader"></icu-icon>
                  </div>
                  <div
                    v-else
                    class="pc-action-btn"
                    @click="addWithdraw(false)"
                  >
                    <icu-icon class="pc-wallet"></icu-icon>
                    <span>{{ $t('pc.accounts.withdraw-make') }}</span>
                  </div>
                </template>
              </template>
            </div>

          </template>

          <div class="pc-details">
            <div class="pc-iban">
              {{ accountData.iban }}
            </div>
            <div class="pc-bank">
              {{ accountData.bank }}
            </div>
          </div>
          <div class="pc-account-cards">
            <div v-for="card in accountData.cards" :key="card.uuid">
              <div class="pc-account-card">
                {{ hideCardNumber(card.card_number) }}
              </div>
            </div>
          </div>
          <icu-icon v-if="!['account', 'inactive-account', 'inactive'].includes(type)" class="pc-bank-card__delete pc-delete" @click="$emit('delete-card',accountData.id)" />
        </template>
        <template v-else>
          <div class="pc-bank-card__add-new">
          </div>
        </template>
      </div>

    </div>

  </div>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon'
import PcCheckboxInput from '@/components/inputs/PcCheckboxInput'
import {mapGetters} from 'vuex'
import PcButton from '@/components/common/PcButton'
import PcModalWrapper from '@/components/modals/PcModalWrapper.vue'
import PcModalContainer from '@/components/modals/PcModalContainer.vue'
import PcBankCard from '@/components/views/PrivateCabinet/PcBankCard.vue'


export default {
  name: 'PcVerifiedAccount',
  components: {
    PcBankCard,
    PcModalContainer, PcModalWrapper,
    PcButton,
    PcCheckboxInput,
    IcuIcon},
  currencies: {
    '1': {
      name: 'pc.accounts.uah',
      symbol: 'uah'
    },
    '2': {
      name: 'pc.accounts.usd',
      symbol: 'usd'
    },
    '3': {
      name: 'pc.accounts.eur',
      symbol: 'eur'
    }
  },
  props: {
    type: {
      type: String,
      default: 'active' // ['active', 'inactive', 'account', 'blank', 'inactive-account']
    },
   accountData: {
      type: Object,
      default: () => {}
    },
    currenciesForPayoutSet:{
      type: Array,
      default: ()=>[]
    }
  },
  data() {
    return {
      currency: [],
    }
  },
  computed: {
    currencies() {
      if(this.accountData?.currency) {
        return [...this.accountData.currency].sort()
      }
      return []
    },
    noNeedToShowModal(){
      return this.currenciesForPayoutSet.length < 2
    }
  },
  mounted() {
    if(this.accountData) {
      this.currency = this.accountData.currency
    }
  },
  methods: {
    showCardManage() {
      this.$emit('manage-cards', this.accountData)
    },
    hideCardNumber(number) {
      return '**** ' + number.substr(number.length - 4)
    },
    updateCurrency(val) {
      if(this.currency.includes(val)) {
        this.currency = this.currency.filter(el => el !== val)
      } else {
        this.currency.push(val)
      }
    },
    formatCardNumber(card_number) {
      const parts = []

      for (let i = 0, len= card_number.length; i < len; i+=4) {
        parts.push(card_number.substring(i, i+4))
      }
      return  parts.join(' ')
    },
    addWithdraw(isChoosenCurrency) {
      const currencyPopover = document.querySelector(' body > .v-popper--theme-pc-currency-change')
      if(currencyPopover) {
        currencyPopover.remove()
      }
      this.$emit('set-payment', {account: this.accountData, currency: isChoosenCurrency? this.currency.filter(el => el !== 1) : this.currenciesForPayoutSet})
    },

  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/theme.scss";

.pc-bank-card-wrap {
  padding: 24px;
}
.pc-bank-card {
  position: relative;
  width: 370px;
  height: 234px;
  padding: 16px;
  box-shadow: 0px 5px 9px 0px #4A495926;
  border-radius: 10px;
  background: url('~@/assets/img/pc/сard_red.jpg');


  * {
    color: $white;
  }


  &__delete {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }


  &__content {
    position: relative;
    height: 100%;
  }

  &__data {
    position: absolute;
    width: 100%;
    left: 0;
    top: 90px;
  }

  &__number {
    font-weight: 500;
    font-size: 24px;
    letter-spacing: 1.4px;
  }

  &__expired {
    color: #A9A9A9;
    font-weight: 500;
    font-size: 18px;
  }

  &.active {
    background: url('~@/assets/img/pc/card_blue.jpg');
  }

  &.inactive, &.inactive-account {
    background: url('~@/assets/img/pc/сard_gray.jpg');
  }

  &.blank {
    background: linear-gradient(90deg, rgba(7, 32, 57, 0.2) 0%, rgba(113, 187, 227, 0.2) 100%),
    linear-gradient(0deg, #D1D1D1, #D1D1D1);
    cursor: pointer;

  }
  &__in-process {
    position: absolute;
    right: 0;
    font-size: 14px;
    color: $gray;
    display: flex;
    align-items: center;
    .pc-clock {
      margin-right: 8px;
    }
  }

  &__add-new {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;

    &:before, &:after {
      content: '';
      display: block;
      width: 40px;
      height: 2px;
      background: #ffffff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform-origin: 50% 50%;
      transform: translate(-50%, -50%);
    }
    &:after {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }

  @media (max-width: $desktop){
    width: 322px;
    height: 210px;

    &__data {
      top: 60px

    }
    &__number {
      font-size: 20px;
    }
    &__expired {
      font-size: 16px;
    }

    .pc-swift {
      font-size: 16px;
    }
    .pc-iban{
      font-size: 12px;
    }
    .pc-bank{
      font-size: 12px;
      padding-top: 5px;
    }

    .pc-action-btn{
       & > *{
         font-size: 12px;
       }
    }
    .pc-add-card{
      font-size: 12px;
    }
  }
}

.pc-currencies {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
}
.pc-currency {
  font-weight: 500;
  font-size: 26px;
  margin-right: 10px;
  opacity: .75;

  .active {
    background: #FF5F00;

  }
}
.pc-details {
  position: absolute;
  top: 42px;
  left: 0;
}
.pc-swift {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;

  span {
    margin-right: 4px;
  }
}

.pc-iban {
  font-weight: 500;
  font-size: 18px;
  line-height: 17px;
}

.pc-actions {
  position: absolute;
  bottom: 0;
  right: 0;
}
.pc-action-btn {
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 5px 4px;
  border-radius: 10px;
  width: 170px;
  height: 32px;
  background: #FFFFFF2B;
  cursor: pointer;
  &.loading {
    display: flex;
    justify-content: center;
    align-items: center;

    .icu-icon {
      width: 20px;
      height: 20px;
    }
  }


  span {
    font-size: 12px;
    color: $white;
    font-weight: 500;
  }

  .pc-wallet {
    flex-shrink: 0;
    margin-right: 7px;
  }
}
.pc-add-card {
  height: 36px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  width: 100%;
  background: #FFFFFF2B;
  border-radius: 10px;
  cursor: pointer;

  .pc-add {
    margin-right: 6px;
  }
}

.popper__title {
  padding-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
}
.pc-checkbox {
  padding: 20px 0;
}

.poper__confirm {
  width: 100%;
  box-shadow: none;
  background: $white !important;
  border: 1px solid #F6F6F6;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;

  &.disabled {
    background: #f6f6f6 !important;
    cursor: default;
    opacity: 0.5;
  }
}
.poper__confirm-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding: 20px 0;
}

.pc-account-cards {
  position: absolute;
  bottom: 0;
  left: 0;

}

.pc-account-card {
  font-weight: 500;
  font-size: 14px;
  padding: 5px 0 5px 37px;
  letter-spacing: 1px;
  background: url(~@/assets/img/components/common/IcuIcon/pc-card-small.svg) no-repeat left center;
}

.inactive {
  .pc-account-card {
    background: url(~@/assets/img/components/common/IcuIcon/pc-card-small-inactive.svg) no-repeat left center;
  }
}
.pc-edit {
  background: #ffffff;
  margin-left: 4px;
  margin-right: 10px;
}
.pc-iban {
  text-shadow: 0px 4px 4px #14141459;
}

@media (max-width: $desktop) {

  .pc-bank-card-wrap {
    max-width: 346px;
    padding-left: 12px;
    padding-right: 12px;
  }

}

.pc-bank {
  font-size: 12px;
  font-weight: 500;
  padding-top: 14px;
  text-transform: uppercase;
  text-shadow: 0px 4px 4px #14141459;
}


</style>
